{
  "title": "Setări",
  "tabs": {
    "general": "General",
    "tags": "Etichete",
    "dance": "Configurare dans",
    "eventTypes": "Tipuri de evenimente",
    "billing": "Facturare",
    "email": "E-mail",
    "media": "Media",
    "calendar": "Calendar",
    "notifications": "Notificări",
    "appearance": "Aspect",
    "features": "Funcții",
    "contract": "Termeni și condiții",
    "backup": "Copie de rezervă și restaurare"
  },
  "status": {
    "label": "Stare:",
    "enabled": "Activat",
    "disabled": "Dezactivat"
  },
  "actions": {
    "add": "Adaugă",
    "edit": "Editează",
    "delete": "Șterge",
    "remove": "Elimină",
    "enable": "Activează",
    "disable": "Dezactivează",
    "archive": "Arhivează",
    "restore": "Restaurează",
    "close": "Închide",
    "copy": "Copiază"
  },
  "general": {
    "schoolIdentity": "Identitatea școlii",
    "schoolFallback": "Școală",
    "logo": "Logo",
    "logoHint": "Apasă pe imagine pentru a încărca un fișier PNG, JPG sau WebP. Apare în meniu și pe pagina de autentificare.",
    "removeLogo": "Elimină logoul",
    "schoolName": "Numele școlii",
    "tagline": "Slogan",
    "taglinePlaceholder": "Apare sub nume pe pagina de autentificare",
    "contactDetails": "Date de contact",
    "contactEmail": "E-mail de contact",
    "phone": "Telefon",
    "website": "Site web",
    "address": "Adresă",
    "regional": "Regional",
    "timezone": "Fus orar",
    "defaultLanguage": "Limbă implicită",
    "primaryCurrencyNote1": "Moneda principală este",
    "primaryCurrencyNote2": "— schimb-o din",
    "primaryCurrencyNote3": "(re-înregistrează registrul contabil).",
    "breakMonths": "Luni de pauză",
    "breakMonthsHintPre": "Lunile în care școala este în pauză (se repetă în fiecare an). Cursurile recurente sunt suspendate, iar taxele lunare urmează regula de pauză a fiecărei taxe (setată per taxă în",
    "breakMonthsHintPost": ").",
    "saving": "Se salvează…",
    "saveChanges": "Salvează modificările",
    "months": {
      "jan": "Ian",
      "feb": "Feb",
      "mar": "Mar",
      "apr": "Apr",
      "may": "Mai",
      "jun": "Iun",
      "jul": "Iul",
      "aug": "Aug",
      "sep": "Sep",
      "oct": "Oct",
      "nov": "Nov",
      "dec": "Dec"
    }
  },
  "tags": {
    "newTag": "Etichetă nouă",
    "namePlaceholder": "Numele etichetei",
    "colorLabel": "Culoarea etichetei",
    "addTag": "Adaugă etichetă",
    "empty": "Nicio etichetă încă"
  },
  "dance": {
    "categoriesTypes": "Categorii și tipuri",
    "newCategory": "Categorie nouă",
    "categoryPlaceholder": "Numele categoriei",
    "addCategory": "Adaugă categorie",
    "typePlaceholder": "Tip nou…",
    "addType": "Adaugă tip",
    "levelsHeading": "Niveluri",
    "levelPlaceholder": "Nivel nou…",
    "addLevel": "Adaugă nivel"
  },
  "eventTypes": {
    "hint": "Categoriile disponibile la crearea unui eveniment (Competiție, Spectacol, Atelier…). Un tip folosit încă de evenimente existente nu poate fi șters.",
    "newType": "Tip nou de eveniment",
    "placeholder": "ex. Recital",
    "addType": "Adaugă tip",
    "empty": "Niciun tip de eveniment încă"
  },
  "billing": {
    "primaryCurrencyHeading": "Moneda principală",
    "primaryCurrencyHint": "Moneda în care este raportată contabilitatea. Plățile și cheltuielile în alte monede sunt convertite în ea (la cursul de la data tranzacției) pentru situația financiară.",
    "currencyCode": "Cod monedă",
    "currencyCodePlaceholder": "ex. RON",
    "primaryCurrencyNote": "Schimbarea ulterioară nu reconvertește înregistrările trecute — seteaz-o înainte de a înregistra plăți.",
    "currenciesHeading": "Monede",
    "currenciesHint": "Monedele în care tranzacționează școala. Acestea sunt singurele opțiuni oferite la înregistrarea taxelor, cheltuielilor și plăților pentru evenimente — astfel codurile rămân consecvente (fără greșeli de scriere sau diferențe de majuscule).",
    "code": "Cod",
    "codePlaceholder": "ex. EUR",
    "nameOptional": "Nume (opțional)",
    "namePlaceholder": "ex. Euro",
    "noCurrencies": "Nicio monedă încă.",
    "primarySuffix": "· principală",
    "inUse": "în uz",
    "feeDefinitionsHeading": "Definiții taxe",
    "feeName": "Nume",
    "feeNamePlaceholder": "ex. Taxă lunară",
    "feeType": "Tip",
    "feeTypes": {
      "monthly": "Lunar",
      "yearly": "Anual",
      "occasional": "Ocazional",
      "event": "Eveniment"
    },
    "billed": "Facturare",
    "scope": {
      "student": "Per cursant",
      "household": "Per familie"
    },
    "amount": "Sumă",
    "defaultAmount": "Sumă implicită",
    "selectPlaceholder": "Selectează…",
    "dueDay": "Ziua scadenței",
    "breakBehavior": "În lunile de pauză",
    "breakBehaviors": {
      "bill": "Facturează normal",
      "pause": "Suspendă",
      "reduce": "Reduce cu %"
    },
    "reduceBy": "Reduce cu %",
    "addFee": "Adaugă taxă",
    "familyShort": "familie",
    "studentShort": "cursant",
    "dueDaySuffix": "ziua scadenței {day}",
    "archivedSuffix": "arhivată",
    "paymentsOne": "{count} plată",
    "paymentsMany": "{count} plăți",
    "historyOnly": "istoric — doar arhivare",
    "historyOnlyTitle": "Taxele cu istoric de plăți nu pot fi editate sau șterse — arhivează-le în schimb",
    "noFees": "Nicio taxă definită încă",
    "priceTiersHeading": "Niveluri de preț",
    "tierName": "Nume",
    "tierNamePlaceholder": "ex. Reducere pentru frați",
    "adjustment": "Ajustare",
    "adjustmentTypes": {
      "percent": "Procent (%)",
      "fixed": "Sumă fixă"
    },
    "value": "Valoare",
    "addTier": "Adaugă nivel",
    "noAdjustment": "fără ajustare",
    "default": "implicit",
    "methodsHeading": "Metode de plată",
    "methodsHint": "Modalitățile offline prin care încasezi (numerar, transfer bancar, Revolut, …). Cea implicită este preselectată la înregistrarea unei plăți. Plățile cu cardul prin Stripe se configurează mai jos.",
    "addMethodLabel": "Adaugă o metodă",
    "addMethodPlaceholder": "ex. Transfer bancar",
    "addMethod": "Adaugă metodă",
    "methodCard": "card · Stripe",
    "methodOffline": "offline",
    "disabledSuffix": "dezactivată",
    "managedBelow": "gestionată mai jos",
    "makeDefault": "Setează ca implicită",
    "stripeHeading": "Stripe (plăți cu cardul)",
    "stripeMode": {
      "test": "Mod test",
      "live": "Mod live",
      "none": "Neconfigurat"
    },
    "stripeDevPre": "Dezvoltarea locală folosește",
    "stripeDevStrong": "chei sandbox din",
    "stripeDevPost": ". Cheile sunt fixe aici, dar poți totuși activa/dezactiva plățile cu cardul.",
    "stripeNoKeyPre": "Cheia de criptare nu este configurată. Rulează",
    "stripeNoKeyPost": "și redistribuie înainte de a salva cheile Stripe (secretele sunt criptate în repaus cu ea). Este separată de orice cheie de licență a produsului.",
    "stripeErrorPre": "Cheile Stripe stocate nu au putut fi decriptate:",
    "stripeErrorMid": ". Verifică dacă",
    "stripeErrorPost": "corespunde valorii folosite când au fost salvate.",
    "stripeStatusUse": "Când este activat, cursanții pot plăti taxele restante cu cardul din portalul lor.",
    "stripeEnable": "Activează plățile cu cardul",
    "stripePublishable": "Cheie publicabilă",
    "stripeSecret": "Cheie secretă",
    "stripeWebhook": "Secret de semnare webhook",
    "stripeWebhookHelp1": "În panoul Stripe, adaugă un endpoint webhook pentru evenimentul",
    "stripeWebhookHelp2": "care să indice către:",
    "stripeWebhookHelp3": "apoi lipește mai sus secretul său de semnare. O cheie restricționată (",
    "stripeWebhookHelp4": ") limitată la Checkout + PaymentIntents este recomandată în locul cheii secrete complete.",
    "stripeSaveDev": "Salvează activare/dezactivare plăți cu cardul",
    "stripeSave": "Salvează setările Stripe",
    "remindersHeading": "Memento-uri și penalități de întârziere",
    "remindersHint": "O sarcină zilnică marchează plățile restante, trimite memento-uri la scadență și aplică penalități de întârziere conform acestor reguli.",
    "sendReminders": "Trimite memento-uri de plată",
    "daysBefore": "Zile înainte de scadență",
    "applyLateFees": "Aplică penalități de întârziere",
    "lateFeeAmount": "Suma penalității de întârziere",
    "graceDays": "Zile de grație",
    "saveAutomation": "Salvează automatizarea",
    "savedPlaceholder": "•••••••• (salvat — lasă gol pentru a păstra)"
  },
  "email": {
    "noAccessHeading": "E-mail",
    "noAccess": "Nu ai acces la setările de e-mail.",
    "providerHeading": "Furnizor de e-mail",
    "devOverridePre": "Dezvoltarea locală folosește cheia sandbox {provider} din",
    "devOverridePost": ". Modul sandbox este activ, deci e-mailurile sunt validate, dar nu sunt livrate niciodată.",
    "blockedPre": "Cheia de criptare nu este configurată — setează secretul Worker",
    "blockedPost": "înainte de a salva o cheie API.",
    "statusUse": "Folosit pentru campanii de mesaje și e-mailuri tranzacționale (invitații, notificări).",
    "sandboxSuffix": " · sandbox (fără livrare reală)",
    "enableSending": "Activează trimiterea de e-mailuri",
    "provider": "Furnizor",
    "fromAddress": "Adresă expeditor (expeditor verificat)",
    "fromAddressPlaceholder": "salut@scoalata.com",
    "fromName": "Nume expeditor",
    "fromNamePlaceholder": "Școala ta de dans",
    "apiKey": "Cheie API {provider}",
    "save": "Salvează setările de e-mail",
    "fromNameHint": "Lasă gol pentru a folosi numele școlii."
  },
  "media": {
    "noAccessHeading": "Media",
    "noAccess": "Nu ai acces la setările media.",
    "uploadRules": "Reguli de încărcare",
    "uploadRulesHint": "Limite aplicate când administratorii sau cursanții încarcă în galerie. Tipuri permise: JPEG, PNG, WebP, GIF (fotografii); MP4, MOV, WebM (videoclipuri).",
    "maxPhoto": "Dimensiune maximă foto (MB)",
    "maxVideo": "Dimensiune maximă video (MB)",
    "maxVideoDuration": "Durată maximă video (secunde)",
    "save": "Salvează setările media"
  },
  "calendar": {
    "featureHeading": "Funcția calendar",
    "enableFeeds": "Activează fluxurile de calendar",
    "enableFeedsHint": "Când este dezactivată, toate fluxurile iCal private încetează să funcționeze, iar portalul ascunde pagina de abonare.",
    "yourFeed": "Fluxul tău:",
    "itemsHeading": "Elemente publice de calendar",
    "itemsHint": "Acestea apar în fluxul de calendar al tuturor — folosește-le pentru petreceri, întâlniri și date importante.",
    "title": "Titlu",
    "date": "Dată",
    "startTime": "Ora de început (opțional)",
    "endTime": "Ora de sfârșit (opțional)",
    "description": "Descriere (opțional)",
    "addItem": "Adaugă element",
    "hidden": "Ascuns",
    "emptyItems": "Niciun element personalizat încă"
  },
  "notifications": {
    "heading": "Notificări pentru administratori",
    "hint": "Alege ce alerte pentru personal sunt trimise. Notificările de plată și de curs pentru cursanți sunt trimise mereu și nu pot fi dezactivate.",
    "newStudent": {
      "label": "Cursant nou înregistrat",
      "desc": "Când un cursant finalizează înscrierea."
    },
    "paymentOverdue": {
      "label": "Plăți restante",
      "desc": "Când plățile devin restante (verificat zilnic)."
    },
    "mediaSubmitted": {
      "label": "Media în așteptarea aprobării",
      "desc": "Când un cursant trimite o fotografie sau un videoclip spre aprobare."
    },
    "eventInterest": {
      "label": "Interes pentru eveniment",
      "desc": "Când un cursant își exprimă interesul pentru un eveniment."
    }
  },
  "appearance": {
    "heading": "Temă",
    "hint": "Alege tema de culori a școlii. Se aplică tuturor, în zona de administrare și în portalul elevilor.",
    "current": "Curentă",
    "darkModeHint": "Modul luminos sau întunecat este o alegere personală — schimbă-l oricând cu butonul soare/lună din bara de sus.",
    "saved": "Temă actualizată"
  },
  "features": {
    "heading": "Comutatoare de funcții",
    "hint": "Activează sau dezactivează funcțiile majore. Când o funcție este dezactivată, intrarea sa de navigare și ecranele aferente sunt ascunse.",
    "flags": {
      "events": {
        "label": "Evenimente",
        "desc": "Gestionarea evenimentelor, înscrierea și secțiunea de evenimente."
      },
      "media": {
        "label": "Galerie media",
        "desc": "Galerii foto/video și încărcări."
      },
      "mailing": {
        "label": "Mesaje",
        "desc": "Liste de distribuție și campanii de e-mail în masă."
      },
      "calendar": {
        "label": "Calendar",
        "desc": "Fluxuri iCal private și pagina de abonare din portal."
      },
      "attendance": {
        "label": "Prezență",
        "desc": "Urmărirea prezenței pentru sesiunile de curs."
      },
      "module_irish_dance": {
        "label": "Modul Dans irlandez",
        "desc": "Treceri la competiții (stele) și examene de grad pentru elevii de dans irlandez."
      }
    }
  },
  "contract": {
    "heading": "Termeni și condiții",
    "loadFile": "Încarcă fișier…",
    "writeHelp1": "Scrie în Markdown sau încarcă un fișier",
    "writeHelp2": ".",
    "legacyNote": "Această versiune a fost creată în editorul vechi, așa că sursa Markdown este goală. Încarcă un fișier sau scrie termenii, apoi publică pentru a o converti.",
    "publish": "Publică",
    "currentVersion": "Curentă: versiunea {version}",
    "noneYet": "Niciun set de termeni publicat încă",
    "versionHistory": "Istoric versiuni",
    "version": "Versiunea {version}",
    "accepted": "{count} acceptate",
    "view": "Vezi",
    "noVersions": "Nicio versiune încă.",
    "modalHeading": "Termeni și condiții — versiunea {version}",
    "publishedByOne": "Publicat {date} · acceptat de {count} cursant.",
    "publishedByMany": "Publicat {date} · acceptat de {count} cursanți.",
    "noContent": "Această versiune nu are conținut."
  },
  "backup": {
    "types": {
      "daily": "Zilnic",
      "weekly": "Săptămânal",
      "monthly": "Lunar",
      "manual": "Manual",
      "pre_update": "Înainte de actualizare"
    },
    "createHeading": "Creează o copie de rezervă",
    "createHint": "Realizează imediat o copie a bazei de date. Copiile manuale nu expiră niciodată — șterge-le tu când nu mai sunt necesare. Copiile automate zilnice/săptămânale/lunare rulează noaptea și sunt curățate conform politicii de retenție (7 zile / 4 săptămâni / 12 luni).",
    "nameLabel": "Numele copiei de rezervă",
    "namePlaceholder": "ex. Înainte de restructurarea sezonului",
    "create": "Creează copie de rezervă",
    "listHeading": "Copii de rezervă",
    "emptyHeading": "Nicio copie de rezervă încă",
    "emptyMessage": "Creează una mai sus sau așteaptă copia automată de noapte.",
    "download": "Descarcă",
    "restore": "Restaurează",
    "retentionManaged": "gestionat prin retenție",
    "retentionTitle": "Copiile automate sunt gestionate de politica de retenție",
    "expiresSuffix": "expiră {date}",
    "restoreHeading": "Restaurează copia de rezervă",
    "restoreBody1": "Restaurarea copiei",
    "restoreBody2": "({date}) va",
    "restoreReplace": "înlocui întreaga bază de date curentă",
    "restoreBody3": "cu această copie. Aplicația intră în mod de mentenanță pe durata operațiunii. Acțiunea nu poate fi anulată.",
    "typeConfirm1": "Scrie",
    "typeConfirm2": "pentru a confirma.",
    "restoreDb": "Restaurează baza de date"
  },
  "toast": {
    "schoolNameRequired": "Numele școlii este obligatoriu",
    "schoolSaved": "Setările școlii au fost salvate",
    "logoRemoved": "Logo eliminat",
    "settingsSaved": "Setări salvate",
    "feedCopied": "Adresa fluxului a fost copiată",
    "copyFailed": "Copierea a eșuat",
    "titleDateRequired": "Titlul și data sunt obligatorii",
    "calItemAdded": "Element de calendar adăugat",
    "mediaSaved": "Setările media au fost salvate",
    "emailSaved": "Setările de e-mail au fost salvate",
    "currencyCode3Ron": "Introdu un cod de monedă din 3 litere (ex. RON)",
    "primaryCurrencySaved": "Moneda principală a fost salvată",
    "currencyCode3Eur": "Introdu un cod de monedă din 3 litere (ex. EUR)",
    "currencyAdded": "Monedă adăugată",
    "currencyRemoved": "Monedă eliminată",
    "billingSaved": "Setările de facturare au fost salvate",
    "stripeSaved": "Setările Stripe au fost salvate",
    "feeFieldsRequired": "Numele, suma și moneda sunt obligatorii",
    "feeCreated": "Taxă creată",
    "tierNameRequired": "Numele nivelului este obligatoriu",
    "tierCreated": "Nivel de preț creat",
    "methodNameRequired": "Introdu un nume de metodă",
    "methodAdded": "Metodă de plată adăugată",
    "defaultMethodSet": "Metodă implicită setată",
    "methodDeleted": "Metodă de plată ștearsă",
    "feeNameCurrencyRequired": "Numele și moneda sunt obligatorii",
    "feeUpdated": "Taxă actualizată",
    "feeArchived": "Taxă arhivată",
    "feeRestored": "Taxă restaurată",
    "feeDeleted": "Taxă ștearsă",
    "importTypeError": "Doar fișierele Markdown (.md) sau text (.txt) pot fi importate",
    "fileTooLarge": "Fișier prea mare (maximum 1 MB de text)",
    "fileLoaded": "Fișier încărcat în editor",
    "fileReadError": "Fișierul nu a putut fi citit",
    "contractEmpty": "Contractul este gol",
    "contractPublished": "Contract publicat",
    "tagCreated": "Etichetă creată",
    "eventTypeCreated": "Tip de eveniment creat",
    "eventTypeDeleted": "Tip de eveniment șters",
    "backupNameRequired": "Introdu un nume pentru copia de rezervă",
    "backupCreated": "Copie de rezervă creată",
    "backupDeleted": "Copie de rezervă ștearsă",
    "restoredOne": "S-au restaurat {rows} rând în {tables} tabele",
    "restoredMany": "S-au restaurat {rows} rânduri în {tables} tabele"
  }
}
